import {ShippingAddressRequest} from "./shippingAddressRequest";
import {ShippingType} from "../enums/ShippingType";

export class OrderRequest {
  shoppingCartId: number;
  promoCode: string;
  shippingMethod: ShippingType;
  totalAmount: number;
  shippingAddress: ShippingAddressRequest;
  shippingAddressId: number | null;

  constructor(shoppingCartId: number, promoCode: string, shippingMethod: ShippingType, totalAmount: number, shippingAddress: ShippingAddressRequest, shippingAddressId: number | null) {
    this.shoppingCartId = shoppingCartId;
    this.promoCode = promoCode;
    this.shippingMethod = shippingMethod;
    this.totalAmount = totalAmount;
    this.shippingAddress = shippingAddress;
    this.shippingAddressId = shippingAddressId;
  }
}
